import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, Inject, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { SeoService } from '../../services/seo.service';
import { element } from 'protractor';
import { DOCUMENT } from '@angular/common';

declare var window: any;

@Component({
  selector: 'app-cryptmi',
  templateUrl: './cryptmi.component.html',
  styleUrls: ['./cryptmi.component.scss']
})
export class CryptmiComponent implements OnInit, OnDestroy {
  hash: any;

  public itsMobile = false;

  public video1: boolean;
  public video2: boolean;
  public video3: boolean;
  public video4: boolean;
  public video5: boolean;
  public video6: boolean;
  public video7: boolean;
  public video8: boolean;
  public video9: boolean;

  public path: string;
  // public position:boolean = true;
  public active: any;
  public hide: any;
  public fixed: boolean;

  constructor(private sanitizer: DomSanitizer, private title: Title, private seo: SeoService, private route: ActivatedRoute, location: Location, router: Router, private el: ElementRef, @Inject(DOCUMENT) private document: any) {
    this.hash = window.location.hash;
    router.events.subscribe((val) => {
      this.path = location.path();
      this.path = this.path.substring(1);
    });
  }

  ngOnInit(): void {
    const theTitle = 'gennius.xyz - Building Human-to-Human technologies';
    this.title.setTitle(theTitle);

    this.seo.generateTags({
      title: theTitle, //'cryptMi: the first dynamic card that blends rewards, crypto & local currencies.',
      keyword: 'rewards, cryptocurrencies, crypto, cashback, points, miles, digital card, digital payment, loyalty rewards, redemptions, digital assets, bank cards, bank directs, smart payments, virtual card, metaverse, NFT',
      // tslint:disable-next-line:max-line-length
      description: "Transfer your digital assets into cryptMi and blend rewards, miles, bank cards and crypto. Make instant swaps between rewards, crypto and your local currency to pay for everyday essentials. Earn rewards with every transaction. ",
      image: './assets/img/cryptmi/share-cryptmi.jpg'
    });

    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    // Loads the images and videos
    this.loadAssets();

    this.document.documentElement.classList.add('block-scroll');
  }

  ngOnDestroy(): void {
    this.document.documentElement.classList.remove('block-scroll');
  }

  @ViewChild("cryptmi") cryptmi: ElementRef;

  @HostListener('body:scroll', ['$event'])
  onScrollingEvent($event): void {
    let scrollOffset = $event.target.scrollTop;
    const section1 = this.cryptmi.nativeElement.offsetTop;
    if (scrollOffset >= section1 - 80) {
      this.fixed = true;
    } else {
      this.fixed = false;
    }
  }

loadAssets() {
    let elementsSrc = document.querySelectorAll('[src-tmp]');

    elementsSrc.forEach((theElement: any) => {
      if (theElement.src != undefined) {
        theElement.src = theElement.getAttribute('src-tmp');
        theElement.removeAttribute('src-tmp');
      }
    });
}

  // @HostListener('body:scroll', ['$event'])
  // onScrollingEvent($event): void {
  //   this.loadAssets();
  //   let scrollOffset = $event.target.scrollTop;
  //   if (scrollOffset > 0) {
  //     this.position = true;
  //   } else {
  //     this.position = false;
  //   }
  // }

  topPage() {
    window.scrollTo(0, 0);
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }


  SlideOptions = {
    items: 1,
    dots: true,
    nav: false,
    margin: 0,
    stagePadding: 0,
    autoHeight: true,
    loop: false,
    autoplay: false,
  };

  openVideo(number: any) {
    this.loadAssets();
    this["video" + number] = true;

    this.pauseAllVideos();

    setTimeout(() => {
      if (number == '1') {
        const video = this.el.nativeElement.querySelector('video.main-video');
        video.play();
      } else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.video-two');
        video.play();
      }
      else if (number == '4') {
        const video = this.el.nativeElement.querySelector('video.video-nft');
        video.play();
      }
      else if (number == '5') {
        const video = this.el.nativeElement.querySelector('video.video-metaverse');
        video.play();
      }
      else if (number == '6') {
        const video = this.el.nativeElement.querySelector('video.video-travel');
        video.play();
      }
      else if (number == '7') {
        const video = this.el.nativeElement.querySelector('video.video-card');
        video.play();
      }
      else if (number == '8') {
        const video = this.el.nativeElement.querySelector('video.video-bank-card');
        video.play();
      }
      else if (number == '9') {
        const video = this.el.nativeElement.querySelector('video.video-shop');
        video.play();
      }
    }, 1000);

  }

  closeVideo(number: any) {
    this["video" + number] = false;
    if (number == '1') {
      const video = this.el.nativeElement.querySelector('video.main-video');
      video.pause();
    } else if (number == '2') {
      const video = this.el.nativeElement.querySelector('video.video-two');
      video.pause();
    }
    else if (number == '4') {
      const video = this.el.nativeElement.querySelector('video.video-nft');
      video.pause();
    }
    else if (number == '5') {
      const video = this.el.nativeElement.querySelector('video.video-metaverse');
      video.pause();
    }
    else if (number == '6') {
      const video = this.el.nativeElement.querySelector('video.video-travel');
      video.pause();
    }
    else if (number == '7') {
      const video = this.el.nativeElement.querySelector('video.video-card');
      video.pause();
    }
    else if (number == '8') {
      const video = this.el.nativeElement.querySelector('video.video-bank-card');
      video.pause();
    }
    else if (number == '9') {
      const video = this.el.nativeElement.querySelector('video.video-bank-card');
      video.pause();
    }
  }


  Navigate(elem: HTMLElement) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }

  pauseAllVideos(event?) {
    document.querySelectorAll('video').forEach((elem: any) => {
      if (elem) {
        try {
          elem.currentTime = 0;
          elem.load();
          elem.pause();
        } catch (error) {
        }
      }
    });
  }

}
